import { createRequestStorageAccessButton } from './button';

createRequestStorageAccessButton();
